import React from 'react';
import './PartnerPage.css';

import { Heading, PageTitle } from '../../../components';
import { partners } from '../../../constants';



const PartnerPage = () => {
  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Partners'} page={'Partners'} />

      <section className='partners'>

        {/* Section heading */}
        <Heading title={'Our Partners'} subTitle={'Trusted Alliances'} />

        <div className='box-container'>

          {/* Loop through the partners array to display each partner's logo */}
          {partners.map((partner, index) => {
            return (
              <div className='partner-item' key={index}>
                {/* Render the Partner logo */}
                <img src={partner} alt='Partner Logo' />
              </div>
            );
            })
          }

        </div>

      </section>

    </>
  );
}

export default PartnerPage;